import { PlusOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Upload } from 'antd';
import { useState } from 'react';

import ReactQuill from 'react-quill';

import { formValidatorRules, getBase64, validateImage } from '@common/utils';
import CommonPreview from '@components/CommonPreview';

import 'react-quill/dist/quill.snow.css';

const BlogForm = ({
  form,
  onFinish,
  handleShowPrompt,
  isView,
  blogImage = [],
  setBlogImage,
  iconImage = [],
  setIconImage,
  loading,
}) => {
  const { Item } = Form;
  const { required } = formValidatorRules;

  const [visible, setVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState();

  const handleBlogImageChange = (info) => {
    validateImage(info, form, setBlogImage, 'image', true);
  };

  const handleIconImageChange = (info) => {
    validateImage(info, form, setIconImage, 'icon', true);
  };

  const handleBlogImagePreview = async (fileObj) => {
    let preview;
    if (!fileObj?.url && !fileObj?.preview) {
      preview = await getBase64(fileObj?.originFileObj);
    }
    setVisible(true);
    setPreviewImage(fileObj?.url || preview);
  };

  const handleIconImagePreview = async (fileObj) => {
    let preview;
    if (!fileObj?.url && !fileObj?.preview) {
      preview = await getBase64(fileObj?.originFileObj);
    }
    setVisible(true);
    setPreviewImage(fileObj?.url || preview);
  };

  return (
    <>
      <CommonPreview
        visible={visible}
        setVisible={setVisible}
        image={previewImage}
        setImage={setPreviewImage}
      />
      <Form
        layout="vertical"
        form={form}
        loading={loading}
        onFinish={onFinish}
        onFieldsChange={handleShowPrompt}
        disabled={!!isView}
        className={`${isView ? 'common-view-form' : 'form'} master-form`}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Item
              label="Title"
              name="title"
              rules={[{ ...required, message: 'Please Enter Title!' }]}
            >
              <Input placeholder="Enter Title" maxLength={255} />
            </Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Item
              label="Link"
              name="link"
              rules={[
                {
                  ...required,
                  type: 'url',
                  message:
                    'Please enter a valid URL (e.g., https://example.com)',
                },
              ]}
            >
              <Input placeholder="Enter Link" />
            </Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Item label="Description" name="description">
              <ReactQuill
                readOnly={!!isView}
                theme="snow"
                placeholder="Enter Description"
              />
            </Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Item name="image" label="Image">
              <Upload
                name="avatar"
                listType="picture-circle"
                maxCount={1}
                fileList={blogImage}
                beforeUpload={() => false}
                onPreview={handleBlogImagePreview}
                onChange={handleBlogImageChange}
                className="avatar-uploader"
                showUploadList={{
                  showDownloadIcon: false,
                  showPreviewIcon: true,
                  showRemoveIcon: true,
                }}
              >
                {blogImage?.length === 0 && <PlusOutlined />}
              </Upload>
            </Item>
          </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Item name="icon" label="Icon">
              <Upload
                name="avatar"
                listType="picture-circle"
                maxCount={1}
                fileList={iconImage}
                beforeUpload={() => false}
                onPreview={handleIconImagePreview}
                onChange={handleIconImageChange}
                className="avatar-uploader"
                showUploadList={{
                  showDownloadIcon: false,
                  showPreviewIcon: true,
                  showRemoveIcon: true,
                }}
              >
                {iconImage?.length === 0 && <PlusOutlined />}
              </Upload>
            </Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default BlogForm;
